import {
  DatabaseApiKeyService,
  type DatabaseApiKey,
} from '@qdrant/qdrant-cloud-public-api/cluster/auth/v1/database_api_key';
import {
  createDatabaseApiKey,
  deleteDatabaseApiKey,
  listDatabaseApiKeys,
} from '@qdrant/qdrant-cloud-public-api/cluster/auth/v1/database_api_key/connect-query';
import { transport } from '@/api/transport';
import {
  createConnectQueryKey,
  createServiceQueries,
  type DeepOmitProtobufInternals,
  type MutationFactory,
  queryOptions,
  useMutation,
} from '@/connect-query';

export type DatabaseApiKeyDto = DeepOmitProtobufInternals<DatabaseApiKey>;

export const databaseApiKeyV1Service = createServiceQueries(DatabaseApiKeyService, {
  listDatabaseApiKeysQuery: (params) => queryOptions(listDatabaseApiKeys, params, { transport }),
});

export const useCreateApiKeyMutation: MutationFactory<typeof createDatabaseApiKey> = () =>
  useMutation(createDatabaseApiKey, {
    onSuccess: (_, vars, { router }, { client }) =>
      Promise.all([
        client.invalidateQueries({
          queryKey: createConnectQueryKey({
            schema: listDatabaseApiKeys,
            input: { accountId: vars.databaseApiKey?.accountId },
          }),
        }),
        router.invalidate(),
      ]),
  });

export const useDeleteApiKeyMutation: MutationFactory<typeof deleteDatabaseApiKey> = () =>
  useMutation(deleteDatabaseApiKey, {
    onSuccess: (_, vars, { router }, { client }) =>
      Promise.all([
        client.invalidateQueries({
          queryKey: createConnectQueryKey({
            schema: listDatabaseApiKeys,
            input: { accountId: vars.accountId },
          }),
        }),
        router.invalidate(),
      ]),
  });
